'use client'

import * as React from 'react'
import { DataTable } from '@/components/data-table/data-table'
import { useDataTable } from '@/hooks/use-data-table'
import { MainTableState } from '@/lib/utils/table-state-utils'
import { CustomDomainItem } from '@/lib/api/domains'
import type { TableConfig } from '@/types/data-table'
import { DEFAULT_SKELETON_ROWS } from '@/config/data-table'
import { useDomainsTableColumns } from './domains-table-columns'
import { DomainsTableSkeleton } from './DomainsTableSkeleton'

interface DomainsTableProps {
	domains: CustomDomainItem[]
	total: number
	loading: boolean
	onTableStateChange: (state: MainTableState) => void
	onRefetch?: () => void
	config?: TableConfig
	selectedDomain?: CustomDomainItem | null
	onSelectDomain?: (domain: CustomDomainItem | null) => void
}

export function DomainsTable({
	domains,
	total,
	loading,
	onTableStateChange,
	onRefetch,
	config = {},
	selectedDomain,
	onSelectDomain,
}: DomainsTableProps) {
	const columns = useDomainsTableColumns({ 
		onViewDomain: (domain: CustomDomainItem) => onSelectDomain?.(domain) 
	})

	const { table } = useDataTable({
		data: domains,
		columns,
		total,
		config: { ...config, clientMode: true, defaultSorting: [{ id: 'createdAt', desc: true }] },
		onTableStateChange,
		getRowId: (row: CustomDomainItem) => row.id,
	})

	return (
		<DataTable
			table={table}
			isLoading={loading}
			skeletonRows={<DomainsTableSkeleton rows={config.skeletonRows || DEFAULT_SKELETON_ROWS} />}
			onRefresh={onRefetch}
		/>
	)
}

